<template>
  <div class="bb-clients">
     <div class="bb-clients__tabs">
        <Tabs
           :activeTab="activeTab"
           :tabsList="tabsList"
           @updateActiveTab="clickTab"
        />
    </div>
    <div class="bb-clients-header">
      <div class="bb-tabs">
        <div
          v-for="tab in statusTabsList"
          :key="tab.id"
          class="bb-tabs__item"
          :class="{'bb-tabs__item_active' : activeStatusTab === tab.id}"
          @click="updateStatusTab(tab.id)"
        >
          {{ tab.title }}
        </div>
      </div>
      <div class="bb-clients-header-form">
        <div class="bb-clients-header-form-search"
             v-if="activeTab !== 3"
        >
          <input class="bb-clients-header-form-search__input bb-input bb-input_search"
                 type="text"
                 @input="inputSearch"
                 placeholder="Search">
          <i class="icon-search bb-clients-header-form-search__icon"></i>
        </div>
        <SearchVendorTag v-else/>
        <i v-if="activeTab !== 3" class="icon-menu bb-clients-header-form-btn-menu" @click="openMenu = !openMenu"
           v-click-outside="closeMenu">
          <transition name="slide-company">
            <div class="bb-clients-header-form-btn-menu-popup" v-if="openMenu" @mouseleave="openMenu = false">
              <div class="bb-clients-header-form-btn-menu-popup__item"
                   :class="{'bb-clients-header-form-btn-menu-popup__item_disabled': !accessMassMailing}"
                   @click.stop="clickToMenu(itemMenu)"
                   v-if="itemMenu.action"
                   v-for="(itemMenu, index) in popupMenu"
                   :key="itemMenu.title + index">
                {{itemMenu.title}}
              </div>
            </div>
          </transition>
        </i>
        <div v-else class="bb-clients-header-form-btn-menu_none"></div>
        <button class="bb-clients-header-form__btn-add bb-button" @click="newClient()">
          ADD
        </button>
      </div>
    </div>
    <div>
      <template v-if="activeTab === 3">
        <ServiceProviderTable
           :searchValue="searchValue"
           :statusType="activeStatusTab"
        />
      </template>
      <template v-else>
        <ClientsList
            :contactType="activeTab"
            :statusType="activeStatusTab"
            :searchValue="searchValue"
            @checkedClient="checkedClient"
        />
      </template>
    </div>
  </div>
</template>

<script>
import ClientsList from '@/components/Dissemination/Sales/CRM/ContactsTable/ContactsTable'
import {get} from 'lodash'
import {FOUNDER} from '@/constants/roles'
import {CRM_TAB_LIST, CRM_STATUS_TABS} from '@/constants/crm'
import SearchVendorTag from './SearchVendorTag/SearchVendorTag'
import ServiceProviderTable from './ContactsTable/ServiceProviderTable'
import Tabs from '../../../Main/Tabs/Tabs.vue'

export default {
  name: 'Contacts',
  components: {
    Tabs,
    ServiceProviderTable,
    ClientsList,
    SearchVendorTag
  },
  data: function () {
    return {
      tabsList: CRM_TAB_LIST,
      statusTabsList: CRM_STATUS_TABS,
      clientCheckedList: [],
      activeTab: 1,
      activeStatusTab: 1,
      openMenu: false,
      popupMenu: [
        {title: 'Change of responsible'},
        {title: 'Remove'},
        {title: 'Send mail', action: this.sendEmail}
      ],
      searchValue: '',
      searchBySelect: 'name',
      filterByTag: {},
      searchOptions: ['name', 'hashtag'],
      openSelectSearch: false,
      openClientExport: false,
      exportParams: {}
    }
  },
  computed: {
    activeTabRoute () {
      return this.$route.params.tabId
    },
    activeStatusTabRoute () {
      return this.$route.params.statusTabId
    },
    accessMassMailing () {
      const userInfo = this.$store.getters.userInfo
      const isFounder = userInfo.role === FOUNDER.id
      return isFounder || get(userInfo, 'massMailingCheck', '')
    },
    emailStore: {
      get: function () {
        return this.$store.getters.emailStore
      },
      set: function (data) {
        this.$store.dispatch('setEmailStore', data)
      }
    },
    sendMail: {
      get: function () {
        return this.$store.getters.sendMail
      },
      set: function (data) {
        this.$store.dispatch('setSendMail', data)
      }
    }
  },
  beforeMount () {
    if (!this.activeTabRoute || !this.activeStatusTabRoute) {
      const params = {}

      if (!this.activeTabRoute) params.tabId = this.tabsList[0].tabId
      if (!this.activeStatusTabRoute) params.statusTabId = this.statusTabsList[0].tabId

      this.$router.replace({
        params
      })
    }
    this.setStartTab()
  },
  methods: {
    setStartTab () {
      this.activeTab = this._searchStatusTabId(this.activeTabRoute, this.tabsList)
      this.activeStatusTab = this._searchStatusTabId(this.activeStatusTabRoute, this.statusTabsList)
    },
    _searchStatusTabId (activeTabId, tabList) {
      const tab = tabList.find((tab) => tab.tabId === activeTabId)
      return tab ? tab.id : tabList[0].id
    },
    closeMenu () {
      this.openMenu = false
    },
    checkedClient (clientList) {
      this.clientCheckedList = clientList
    },
    inputSearch (e) {
      const val = e.target.value
      const searchValue = val.toLowerCase().trim()
      this.searchValue = val.toLowerCase().trim()
      searchValue ? this.$children[0].searchWords = `&search=${searchValue}` : this.$children[0].searchWords = ''
    },
    setTypeSearch (type) {
      this.filterByTag = {}
      this.searchBySelect = type
      if (type === 'name') {
        const search = this.$refs.bbInputSearch
        if (search) search.value = ''
      }
    },
    clickTab (value) {
      const tabItem = this.tabsList.find((tab) => tab.id === value)
      this.activeTab = value
      this.$router.replace({ params: { tabId: tabItem.tabId } })
    },
    updateStatusTab (value) {
      const tabItem = this.statusTabsList.find((tab) => tab.id === value)
      this.activeStatusTab = value
      this.$router.replace({ params: { statusTabId: tabItem.tabId } })
    },
    newClient () {
      if (this.activeTab === 3) {
        this.$router.push({name: 'ContactServiceProvider', params: {id: 'new', contactType: this.activeTab}})
      } else {
        this.$router.push({name: 'ContactCard', params: {id: 'new', contactType: this.activeTab}})
      }
    },
    clickToMenu (item) {
      if (!this.accessMassMailing) return
      if (typeof item.action === 'function') item.action()
    },
    sendEmail () {
      if (this.clientCheckedList.length > 0) {
        this.$router.push({name: 'MainPageEmail', params: {massMailing: true}})
      }
      this.sendMail = true
      this.emailStore = this.clientCheckedList
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-clients {
  @include global-font;

  &__tabs {
    margin-bottom: 12px;
  }

  &-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    background-color: $color-white;
    z-index: 4;

    &-form {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      flex-basis: 50%;
      padding-right: 25px;

      &__btn-add {
        min-width: 73px;
      }

      &-btn-menu_none {
        width: 15px;
      }

      &-btn-menu {
        flex: 0 0 42px;
        height: 42px;
        position: relative;
        transform: rotate(90deg);
        display: flex;
        justify-content: center;
        align-items: center;
        color: $color-accent;
        font-size: 20px;
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: $color-accent-hover;
        }

        &-popup {
          position: absolute;
          left: -22px;
          top: 86px;
          transform: rotate(-90deg);
          background: $color-white;
          box-shadow: 0 0 10px rgba($color-black, 0.1);
          border-radius: 5px;
          padding: 5px 0;
          min-width: 190px;
          transition: 0.3s;

          &__item {
            @include global-font;
            padding: 13px 18px;
            font-weight: 300;
            font-size: 13px;
            line-height: 16px;
            white-space: nowrap;
            color: $color-black;
            cursor: pointer;
            transition: 0.3s;
            user-select: none;

            &_disabled {
              pointer-events: none;
              color: $color-silver-chalice;
            }

            &:hover {
              background-color: $color-wild-sand;
            }
          }

          &:after {
            content: '';
            position: absolute;
            right: 7px;
            top: -5px;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 5px solid $color-white;
            box-shadow: 0 0 20px rgba($color-black, 0.05);
          }
        }
      }

      &-search {
        position: relative;
        display: flex;
        align-items: center;
        flex-basis: 578px;

        &__input {
          width: 100%;
          height: 42px;
          border-radius: 6px;
          padding-left: 40px;
          border: 1px solid $color-wild-sand;
        }

        &__icon {
          position: absolute;
          left: 13px;
          font-size: 15px;
          z-index: 2;
          color: $color-silver;
        }

        &-select {
          position: absolute;
          display: flex;
          align-items: center;
          right: 14px;
          transition: 0.3s;
          cursor: pointer;
          color: $color-accent;

          &:hover {
            color: $color-accent-hover;
          }

          &__title {
            font-weight: 500;
            font-size: 13px;
            line-height: 16px;
          }

          &__icon {
            font-size: 5px;
            margin-left: 4px;
            transition: 0.3s;

            &_active {
              transform: rotate(180deg);
            }

            &_settings {
              font-size: 14px;
              margin-left: 1px;
            }
          }
        }

        &-options {
          position: absolute;
          top: 20px;
          right: 0;
          display: grid;
          grid-gap: 8px;
          box-shadow: 0 0 15px rgba($color-black, 0.08);
          border-radius: 4px;
          background-color: $color-white;
          padding: 16px 12px;
          z-index: 2;

          &__item {
            font-weight: 500;
            font-size: 13px;
            line-height: 16px;
            color: $color-black;
            transition: 0.3s;

            &:hover {
              color: $color-accent;
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/Contacts.vue